import { Routes, Route, Navigate } from 'react-router-dom';
import SegmentsList from './SegmentsList';
import DetailsSettingRequest from 'components/SettingRequest/DetailsSettingRequest';

const Segments = () => {
  return (
    <Routes>
      <Route
        path=":settingRequestId/details"
        element={<DetailsSettingRequest />}
      />
      <Route path=":segmentId" element={<Navigate relative="path" to=".." />} />
      <Route index element={<SegmentsList />} />
    </Routes>
  );
};

export default Segments;
